<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Герб">
    <app-logotype></app-logotype>
  </mat-tab>
  <mat-tab label="Песня">
    <app-song></app-song>
  </mat-tab>
  <mat-tab label="Законы">
    <app-deviz></app-deviz>
  </mat-tab>
</mat-tab-group>
